import { fetchServices } from '@/api/service'
const getVirtualCreditCardDetail = (context) => {
  fetchServices().then((response) => {
    context.commit(
      'VIRTUALCREDITCARDDETAIL_UPDATED',
      _.find(response, function (o) {
        return o.service_id == 2
      })
    )
  })
}

export default {
  getVirtualCreditCardDetail
}
